var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReinstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4229",
    "data-name": "Group 4229",
    transform: "translate(-1198 -341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2943",
    "data-name": "Group 2943",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2913",
    "data-name": "Group 2913",
    transform: "translate(-12 -422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    transform: "translate(1211 763)",
    fill: "#154c19",
    stroke: "#57912e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 29,
    rx: 4.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "backup",
    d: "M15.149,11.729a5.609,5.609,0,0,1-4.918,3.726q-.189.012-.376.012a5.563,5.563,0,0,1-3.686-1.39c-.046-.04-.091-.082-.136-.123V14.9a.616.616,0,1,1-1.233,0V12.127a.616.616,0,0,1,.616-.616H8.189a.616.616,0,0,1,0,1.233H6.575a4.413,4.413,0,0,0,.407.408,4.374,4.374,0,0,0,7-1.832.616.616,0,1,1,1.163.41Zm-9.99-2.91a.617.617,0,0,0,.581-.412,4.373,4.373,0,0,1,7-1.832,4.423,4.423,0,0,1,.407.408H11.537a.616.616,0,0,0,0,1.233h2.772a.616.616,0,0,0,.616-.616V4.828a.616.616,0,1,0-1.233,0v.944c-.045-.042-.09-.083-.136-.123A5.607,5.607,0,0,0,4.577,8a.617.617,0,0,0,.581.822ZM19.727,9.863A9.863,9.863,0,1,1,9.863,0,9.874,9.874,0,0,1,19.727,9.863Zm-1.233,0a8.63,8.63,0,1,0-8.63,8.63A8.64,8.64,0,0,0,18.494,9.863Z",
    transform: "translate(1203.137 346.137)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinstate);
export default __webpack_public_path__ + "static/media/reinstate.add1bf77966ea0c8fef33d1765ae1729.svg";
export { ForwardRef as ReactComponent };